import { Grid, Switch, Typography } from '@material-ui/core'
import { ChangeEvent, FC, useState } from 'react'
import { FormSpy } from 'react-final-form'
import useLoading from '../../../control/loading/useLoading'
import useTranslate from '../../../i18n/useTranslate'
import usePreferenceProfile from '../../../services/um/usePreferenceProfile'

const NotificationSetting: FC<{}> = () => {
    const translate = useTranslate()
    const preferenceProfileHook = usePreferenceProfile()
    const loadingHook = useLoading()
    const [firstTime, setFirstTime] = useState<boolean>(true)
    const [isEnabled, setIsEnabled] = useState<boolean>(true)

    const handleChangeValue = async (event: ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked
        setIsEnabled(event.target.checked)
        loadingHook.loadingOpen()
        await preferenceProfileHook.putEmailSetting(isChecked)
        loadingHook.loadingClose()
    }

    const subscribeForm = (formState: any) => {
        if (formState.values.enableEmail !== undefined && firstTime) {
            setIsEnabled(formState.values.enableEmail)
            setFirstTime(false)
        }
    }

    return (
        <Grid container>
            <FormSpy onChange={subscribeForm} />
            <Grid item xs={12} md={4}>
                <Typography variant="h6">{translate.get('UM.PROFILE.EMAIL_NOTIFICATION')}</Typography>
            </Grid>
            <Grid item xs={12} md={8}>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs="auto">
                        <Typography variant="body2">{translate.get('LABEL.OFF')}</Typography>
                    </Grid>
                    <Grid item xs="auto">
                        <Switch onChange={handleChangeValue} checked={isEnabled} />
                    </Grid>
                    <Grid item xs="auto">
                        <Typography variant="body2">{translate.get('LABEL.ON')}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default NotificationSetting
